import React, {} from 'react';
import {withAuthenticationRequired} from "@auth0/auth0-react";
import Loading from "../components/common/Loading";
import {Outlet} from "react-router-dom";
import BeheerTopBar from "../flowBeheer/BeheerTopBar";
import BeheerSideNav from "./BeheerSideNav";

const _BeheerMain = ({drawerOpen, setDrawerOpen, collapsed, setCollapsed}) => {
    return (
        <div className="flex flex-col min-h-screen">
            <BeheerTopBar/>
            <BeheerSideNav drawerOpen={drawerOpen}
                           setDrawerOpen={setDrawerOpen}
                           collapsed={collapsed}
                           setCollapsed={setCollapsed}/>
            <div className="flex flex-1">
                <main className="flex-1 p-4 overflow-auto">
                    <Outlet/>
                </main>
            </div>
        </div>
    )
};


export default withAuthenticationRequired(_BeheerMain, {
    onRedirecting: () => <Loading/>,
    returnTo:
        '/beheer'
});
